import api from "../../services/api";

export const FETCH_GEOJSON_REQUEST = "FETCH_GEOJSON_REQUEST";
export const FETCH_GEOJSON_SUCCESS = "FETCH_GEOJSON_SUCCESS";
export const FETCH_GEOJSON_FAILURE = "FETCH_GEOJSON_FAILURE";

export const fetchGeojsonRequest = () => ({
  type: FETCH_GEOJSON_REQUEST,
});

export const fetchGeojsonSuccess = (data) => ({
  type: FETCH_GEOJSON_SUCCESS,
  payload: data,
});

export const fetchGeojsonFailure = (error) => ({
  type: FETCH_GEOJSON_FAILURE,
  payload: error,
});

export const fetchGeojsonData = (start, end) => async (dispatch) => {
  dispatch(fetchGeojsonRequest());
  try {
    const response = await api.get("/geojson/", { params: { start, end } });
    dispatch(fetchGeojsonSuccess(response.data));
  } catch (error) {
    dispatch(fetchGeojsonFailure(error.message));
  }
};
